module.exports = function() {
  return new Worker(__webpack_public_path__ + "9d1574884a55c51192ee.worker.js");
};